<template>
  <div> 
       <Header />

       <div class="md-layout md-alignment-center">
         <div class="md-layout-item md-size-50">
            <h3>Clientes</h3>
            <md-button :to="{ name:'AdmCompanyForm', params:{id:'novo'} }" class="md-raised">Novo cliente</md-button>
            <br><br>
            <Table :items="items" @remove="setRemove" />
         </div>
       </div>

       

  </div>
</template>

<style>
.md-raised{
  margin-left: 0;
}
</style>

<script>

import Header from '@/components/Header.vue'

import Table from './components/Table.vue'

import {mapState,mapActions} from 'vuex'

export default {
  components: {
    Header,
    Table,
  },
  computed:{
    ...mapState("AdmCompany",["items"])
  },  
  methods:{
    ...mapActions("AdmCompany",["setList", "setRemove"]),    
  },
  created(){   
    this.setList()
     
  }
}
</script>
